<div class="container-fluid">
  <div>
    <div class="content">
      <div class="filters" *ngIf="!loading || filteredRentalProducts.length > 0">
        <div>
          <div class="category-filter" *ngIf="categories.length > 0">
            <div>{{ 'bikeshop.rentals.products.category' | translate }}:</div>
            <div>
              <div *ngFor="let category of categories" class="filter-items"
                   (click)="selectCategoryFilter(category)"
                   [ngClass]="{'selected': category.categoryID === selectedCategoryFilter.categoryID}">
                <div><span class="fa"
                           [ngClass]="{ 'fa-minus-circle' : category.categoryID === selectedCategoryFilter.categoryID, 'fa-plus-circle' : category.categoryID !== selectedCategoryFilter.categoryID }"></span>{{category.categoryName}}
                </div>
              </div>
            </div>
          </div>
          <div class="brand-filter" *ngIf="brands.length > 0">
            <div>{{ 'bikeshop.rentals.products.brand' | translate }}:</div>
            <div>
              <div *ngFor="let brand of brands" class="filter-items" (click)="selectBrandFilter(brand)"
                   [ngClass]="{'selected': brand.brand === selectedBrandFilter.brand}">
                <div><span class="fa"
                           [ngClass]="{ 'fa-minus-circle' : brand.brand === selectedBrandFilter.brand, 'fa-plus-circle' : brand.brand !== selectedBrandFilter.brand }"></span>{{brand.brand}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-right">
          <div class="p-inputgroup" style="margin-left: 30px; width: 300px; float: left;">
            <input type="text" pInputText placeholder="{{ 'general.search' | translate }}"
                   (input)="setSearch($event.target['value'])"/>
            <span class="p-inputgroup-addon"><i class="hubtiger-search"></i></span>
          </div>
          <div class="margin-top-16" style="margin-bottom: -36px; display: flex; gap: 16px;">
            <button pButton (click)="navigateImportProducts()" class="p-button-raised"
                    label="Import Products" [disabled]="productLimitReached"
                    style="width: 200px;"></button>

            <button pButton (click)="addNewRentalProduct()" class="p-button-raised"
                    label="{{'bikeshop.rentals.products.add_new_product' | translate}}"
                    [disabled]="productLimitReached"
                    style="width: 200px;"></button>
          </div>
        </div>
      </div>
      <div *ngIf="productLimitReached" class="limit-reached-error">
        {{'bikeshop.rentals.products.product_limit_reached_upgrade' | translate}}
      </div>
      <div class="product-header">
        <div class="chevron"></div>
        <!-- <div class="avatar"></div> -->
        <div>{{ 'bikeshop.rentals.products.brand_model' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.year' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.category' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.quantity' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.sizes' | translate }}</div>
        <div *ngIf="hasDemoProducts" style="max-width:260px;">{{ 'bikeshop.rentals.products.product_type' | translate }}</div>
        <div *ngIf="!hasDemoProducts" class="status-spacer"></div>
        <div *ngIf="!hasDemoProducts" class="action-spacer"></div>
      </div>
      <div *ngIf="loading && filteredRentalProducts.length === 0"
           style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
      </div>
      <div *ngFor="let product of filteredRentalProducts" [ngClass]="{'invalid': !isProductComplete(product)}">
        <div class="product-row">
          <div class="indicator"
               [ngStyle]="{'background-color': '#'+intToRGB(hashCode(product.brand+' '+product.model))}"></div>
          <div class="chevron"><span class="fa" [ngClass]="{'fa-chevron-down': product.brand == expandedProduct.brand
              && product.model == expandedProduct.model
              && product.yearModel == expandedProduct.yearModel
              && product.category == expandedProduct.category,'fa-chevron-right': !(product.brand == expandedProduct.brand
              && product.model == expandedProduct.model
              && product.yearModel == expandedProduct.yearModel
              && product.category == expandedProduct.category)}" (click)="expandProduct(product)"></span>
          </div>
          <!-- <div class="avatar"><avatar size=20 name="{{product.brand+' '+product.model}}" hideName="true"></avatar></div> -->
          <div class="brand">
            <div>{{product.brand}}/{{product.model}}</div>
          </div>
          <div class="year">{{product.yearModel}}</div>
          <div class="category">{{product.categoryName}}</div>
          <div class="year">{{product.rentalProducts.length}}</div>
          <div class="sizes">{{product.sizes.join(", ")}}</div>
          <div *ngIf="hasDemoProducts" style="max-width:260px;">
            <span *ngIf="product.isRental">{{ 'bikeshop.rentals.products.rental_product' | translate }}</span>
            <span *ngIf="product.isRental && product.isDemo">/</span>
            <span *ngIf="product.isDemo" class="red">{{ 'bikeshop.rentals.products.demo_product' | translate }}</span>
          </div>
          <div *ngIf="!hasDemoProducts" class="status-spacer"></div>
          <div *ngIf="!hasDemoProducts" class="action-spacer"></div>
        </div>
        <div *ngIf="product.brand == expandedProduct.brand
                    && product.model == expandedProduct.model
                    && product.yearModel == expandedProduct.yearModel
                    && product.category == expandedProduct.category" class="sub-product-container">
          <div class="sub-product-header">
            <div class="image">{{ 'bikeshop.rentals.products.image' | translate }}</div>
            <div>{{ 'bikeshop.rentals.products.serial_number' | translate }}</div>
            <div>{{ 'bikeshop.rentals.products.price_group' | translate }}</div>
            <div>{{ 'bikeshop.rentals.products.color' | translate }}</div>
            <div>{{ 'bikeshop.rentals.products.size' | translate }}</div>
            <div class="status">{{ 'bikeshop.rentals.products.status' | translate }}</div>
            <div class="action"></div>
          </div>
          <div *ngFor="let item of product.rentalProducts" class="sub-product-row">
            <div class="image">
              <div *ngIf="item.imageURL"><img [src]="item.imageURL"></div>
              <div *ngIf="!item.imageURL"><img src="/assets/no-image-placeholder.png"></div>
            </div>
            <div class="identifier">
              <p-inplace #serialNumber>
                <span pInplaceDisplay>
                  {{item.serialNumber}}
                </span>
                <span pInplaceContent>
                  <div class="p-inputgroup">
                    <input pInputText type="text" [(ngModel)]="item.serialNumber"
                           (keyup.enter)="updateRecord(item, serialNumber)" (blur)="updateRecord(item, serialNumber)"/>
                    <span class="p-inputgroup-addon" (click)="updateRecord(item, serialNumber)"><i class="fa fa-check"
                                                                                                   [ngClass]="{ red: item.serialNumber && item.serialNumber.length > 0 }"></i></span>
                  </div>
                </span>
              </p-inplace>
            </div>
            <div>{{item.priceGroupName}}</div>
            <div>
              <p-inplace #color>
              <span pInplaceDisplay>
                {{item.color}}
              </span>
                <span pInplaceContent>
                <div class="p-inputgroup">
                  <input pInputText type="text" [(ngModel)]="item.color" (keyup.enter)="updateRecord(item, color)"
                         (blur)="updateRecord(item, serialNumber)"/>
                  <span class="p-inputgroup-addon" (click)="updateRecord(item, color)"><i class="fa fa-check"
                                                                                          [ngClass]="{ red: item.color && item.color.length > 0 }"></i></span>
                </div>
              </span>
              </p-inplace>
            </div>
            <div>{{item.size}}</div>
            <div class="status">
              <div [ngClass]="{'available': item.statusID === 10, 'repair': item.statusID === 40}">
                <span class="fa fa-circle"></span>{{item.status}}
              </div>
            </div>
            <div class="action">
              <span class="fa hubtiger-edit" (click)="editProduct(item)"></span>
              <span *ngIf="!productLimitReached" class="fa fa-clone" (click)="cloneProduct(item)"></span>
            </div>
          </div>
        </div>
      </div>


      <div *ngIf="!loading && rentalProducts.length === 0" class="no-products">
        {{ 'bikeshop.rentals.products.no_products' | translate }}
      </div>

    </div>
  </div>

  <p-sidebar #NavSideBar [(visible)]="showRentalProduct" position="right" [autoZIndex]="false"
             [baseZIndex]="0"
             [showCloseIcon]="false"
             [style]="{width:'700px', background: '#F6F6F8', 'overflow-x': 'auto', 'z-index': '1001'}"
             (onHide)="getRentalProducts(); NavSideBar.destroyModal()">
    <div *ngIf="showRentalProduct">
      <app-add-edit-rental-product [product]="selectedProduct" [cloneProduct]="isCloneProduct"
                                   [messageService]="messageService"
                                   (close)="closeRentalProduct()"></app-add-edit-rental-product>
    </div>
  </p-sidebar>
  <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>

</div>
